module.exports = {
	"header.logo.title": "GROHE - Pure Freude an Wasser",
	"footer.privacy.text": "Politique de confidentialité",
	"footer.privacy.url": "https://www.grohe.ch/fr_ch/entreprise-grohe/protections-des-donnees.html",
	"footer.disclaimer.text": "Mentions légales",
	"footer.disclaimer.url": "https://www.grohe.ch/fr_ch/entreprise-grohe/mentions-legales.html",
	"footer.copyright": "&copy; 2017 GROHE Switzerland SA",
	"homepage.headline": "Configurateur de systèmes d'eau GROHE",
	"homepage.introtext": "Il vous suffit de répondre aux quelques questions ci-après pour configurer le système d'eau GROHE qui répondra à vos besoins. ",
	"homepage.buttonStart": "Commencer",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"404.title": "404 Page Not Found",
	"404.link.goBack": "Retour à l'accueil",
	"configurator.button.seeResults": "Voir les résultats",
	"question1.question": "Votre cuisine est-elle équipée d'une arrivée d'eau chaude et d'eau froide?",
	"question1.option1.text": "J'ai une alimentation d'eau chaude dans ma cuisine",
	"question1.option2.text": "J'ai l'eau froide dans la cuisine avec un chauffe-eau instantané installé",
	"question2.question": "Quel type d'eau recherchez-vous?",
	"question2.option1.text": "De l'eau bouillante pour la préparation des repas et des boissons",
	"question2.option2.text": "De l'eau fraîche et pétillante à boire",
	"question2.option3.text": "De l'eau fraîche pétillante et de l'eau bouillante",
	"question3.question": "Souhaitez-vous conserver votre robinet de cuisine actuel?",
	"question3.option1.text": "Je souhaite le garder",
	"question3.option2.text": "Je veux installer un nouveau modèle",
	"question4.question": "Quel sera votre robinet principal?",
	"question4.option1.text": "GROHE Blue Home",
	"question4.option2.text": "GROHE Red",
	"question5.question": "Quel design préférez-vous pour le bec du robinet?",
	"question5.option1.text": "Bec en L",
	"question5.option2.text": "Bec en U",
	"question5.option3.text": "Bec en C",
	"question6.question": "Quel design préférez-vous pour le bec de la robinetterie Mono?",
	"question6.option1.text": "Bec en L",
	"question6.option2.text": "Bec en C",
	"question7.question": "Quelle finition préférez-vous?",
	"question7.option1.text": "Chrome",
	"question7.option2.text": "Supersteel",
	"question8.question": "Quelle taille de chauffe-eau instantané correspond à vos besoins?",
	"question8.option1.text": "Taille M",
	"question8.option2.text": "Taille L",
	"question9.question": "Souhaitez-vous installer un filtre supplémentaire pour adoucir et améliorer l'eau?",
	"question9.option1.text": "Oui",
	"question9.option2.text": "Non",
	"results.title": "{productGroupsCount, plural, \none {Vos résultats} \nother {Votre résultat}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Pour l'installation, vous aurez également besoin de:",
	"results.newConfiguration.title": "Voulez-vous configurer un nouveau système d'eau?",
	"results.newConfiguration.buttonText": "Configurer un nouveau système d'eau",
	"results.product.number": "Référence produit: #{number}",
	"results.product.button.productInformation": "Information sur le produit",
	"results.product.button.dealerLocator": "Trouvez un showroom",
	"results.product.button.buyNow": "Acheter en ligne",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Information sur le produit",
	"results.product.dealer": "Trouvez un showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/water.fr_ch.json
// module id = 773
// module chunks = 0